import { Input } from '@servicetitan/design-system';
import { ComponentProps } from 'react';

export interface SearchFilterProps
  extends Omit<ComponentProps<typeof Input>, 'onChange'> {
  onChange(value: string): void;
}

export const SearchFilter = ({
  onChange,
  className,
  ...props
}: SearchFilterProps) => {
  return (
    <Input
      {...props}
      className={className ?? 'w-25'}
      size='small'
      icon='search'
      iconPosition='left'
      onChange={(_, data) => onChange(data.value)}
    />
  );
};
